import { useTranslation } from 'react-i18next';
import { Shield, CheckCircle } from 'lucide-react';

const LandingPrivacy = () => {
  const { t } = useTranslation();
  const bullets = [
    t('landing.privacyBullet1'),
    t('landing.privacyBullet2'),
    t('landing.privacyBullet3'),
    t('landing.privacyBullet4'),
  ];

  return (
    <section className="py-20 sm:py-28 px-4">
      <div className="max-w-4xl mx-auto text-center space-y-8">
        <div className="mx-auto w-16 h-16 rounded-2xl bg-emerald-500/10 flex items-center justify-center">
          <Shield className="h-8 w-8 text-emerald-500" />
        </div>
        <div>
          <p className="text-sm font-semibold text-emerald-600 dark:text-emerald-400 uppercase tracking-wider mb-2">{t('landing.privacySubtitle')}</p>
          <h2 className="text-3xl sm:text-4xl font-bold">{t('landing.privacyTitle')}</h2>
        </div>
        <p className="text-muted-foreground max-w-2xl mx-auto leading-relaxed">{t('landing.privacyDesc')}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl mx-auto text-start">
          {bullets.map((b, i) => (
            <div key={i} className="flex items-center gap-3 text-sm">
              <CheckCircle className="h-4 w-4 text-emerald-500 shrink-0" />
              {b}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingPrivacy;
